
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  techniciansList: [],
  loading: false,
  error: null,
};

const technicianSlice = createSlice({
  name: 'technician',
  initialState,
  reducers: {
    setTechniciansList: (state, action) => {
      state.techniciansList = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setTechniciansList, setLoading, setError } = technicianSlice.actions;
export default technicianSlice.reducer;
